// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__RQUYD","selected":"styles_selected__PeiX1"};